import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist/dist/umd';

//----------------------------------
// Vuex Store Definition
//----------------------------------
const vuexPersist = new VuexPersist({
  key: 'electricquest',
  storage: localStorage,
});

Vue.use(Vuex);
const vuexStore = new Vuex.Store({
  plugins: [vuexPersist.plugin],
  state: {
    cookies: false,
  },
  getters: {
    cookies(state) {
      return state.cookies;
    },
  },
  mutations: {
    cookies(state, value) {
      state.cookies = value;
    },
  },
});

//----------------------------------
// Exposed Store Definition
//----------------------------------

export default class Store {
  //----------------------------------
  // Public Properties
  //----------------------------------
  static get cookies() {
    return vuexStore.getters.cookies;
  }

  static set cookies(value) {
    vuexStore.commit('cookies', value);
  }
  //----------------------------------
  // Public Methods
  //----------------------------------
}
